import type { FooterColumnSection } from './types'
import { FOOTER_URLS } from './urls'

const S = FOOTER_URLS.sustainability

export const FOOTER_COLUMN_SECTIONS: FooterColumnSection[] = [
    {
        id: 'servicio',
        titleKey: 'footer|service',
        links: [
            {
                href: FOOTER_URLS.helpCenter,
                external: true,
                title: 'Centro de ayuda',
                labelKey: 'footer|help center'
            },
            {
                href: FOOTER_URLS.contact,
                external: true,
                title: 'Contáctanos',
                labelKey: 'footer|contact'
            },
            {
                href: FOOTER_URLS.trackOrder,
                external: true,
                title: 'Rastrea tu pedido',
                labelKey: 'footer|track your order'
            },
            {
                href: FOOTER_URLS.findStore,
                external: true,
                title: 'Encuentra una tienda',
                labelKey: 'footer|find a store'
            },
            {
                href: FOOTER_URLS.exchangeAndReturns,
                external: true,
                title: 'Cambios y devoluciones',
                labelKey: 'footer|exchange and returns'
            },
            {
                href: FOOTER_URLS.clientProgram,
                external: true,
                title: 'Programa de clientes',
                labelKey: 'footer|client program'
            }
        ]
    },
    {
        id: 'descubre',
        titleKey: 'footer|discover',
        titleKeyMobile: 'footer|offers and products',
        links: [
            {
                href: FOOTER_URLS.whatsNew,
                external: false,
                title: 'Lo nuevo',
                labelKey: 'footer|whats new'
            },
            {
                href: FOOTER_URLS.cyberIdeas,
                external: false,
                title: 'Cyber ideas',
                labelKey: 'footer|cyber ideas'
            },
            {
                href: FOOTER_URLS.blackIdeas,
                external: false,
                title: 'Black ideas',
                labelKey: 'footer|black ideas'
            },
            {
                href: FOOTER_URLS.outlet,
                external: false,
                title: 'Liquidación',
                labelKey: 'footer|clearance'
            }
        ]
    },
    {
        id: 'sostenibilidad',
        titleKey: 'footer|sustainability',
        links: [
            {
                href: S,
                external: false,
                title: 'Nuestro compromiso',
                labelKey: 'footer|our commitment'
            },
            {
                href: `${S}#nuestra-estrategia`,
                external: false,
                title: 'Nuestra estrategia',
                labelKey: 'footer|our strategy'
            },
            {
                href: `${S}#nuestras-metas`,
                external: false,
                title: 'Metas y desafíos',
                labelKey: 'footer|goals and challenges'
            },
            {
                href: `${S}/nuestras-metas-y-desafios#reportes`,
                external: false,
                title: 'Reportes de sostenibilidad',
                labelKey: 'footer|sustainability reports'
            },
            {
                href: `${S}#sostenibilidad-casa`,
                external: false,
                title: 'Sostenibilidad en casa',
                labelKey: 'footer|sustainability at home'
            }
        ]
    },
    {
        id: 'nosotros',
        titleKey: 'footer|us',
        titleKeyMobile: 'footer|About us',
        links: [
            {
                href: FOOTER_URLS.aboutUs,
                external: false,
                title: 'Quiénes somos',
                labelKey: 'footer|About us'
            },
            {
                href: FOOTER_URLS.workWithUs,
                external: true,
                title: 'Súmate al equipo',
                labelKey: 'footer|join the team'
            }
        ]
    }
]
